import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppTheme from './Shared-Theme/AppTheme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppTheme>
      <App />
    </AppTheme>
  </BrowserRouter>
);

reportWebVitals();
